import React, { useEffect ,useState} from "react";
import {Empty,Button, Pagination,Badge } from "antd";
import { useNavigate } from "react-router-dom";

import useStatsStore from "../../../store/stats.store";

import TableDashBoard from "../../TableDashBoard";

import "../myDashboardPages.scss";
import Filter from "../../filter";

export default function MyDashBoardSelectionsAndOffers({currentView,cb}) {    
  const {myDashConsolidatedStatsSelectionAndOffers,getMyDashBoardConsolidatedStatsSelectionAndOffers,myDashConsolidatedStatsSelectionAndOffersCount} = useStatsStore();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };  

  useEffect(() => {
    //getAllJds();
  }, []);

  const finalSelectionList = [
    "Sr. No.",    
    "Client",
    "TA Name",
    "Job Title",
    "SPOC",
    "Assigned To",
    "Final Selected",
    "Offered",
    "Accepted",
    "Declined",
    "Joined",
    "Offer on Hold",
    "BGV Ongoing",
    "BGV Fail",
    "BGV OK",
  ];  


  const finalSelectionData = myDashConsolidatedStatsSelectionAndOffers?.offers?.map((offer, idx) => {
    return {
      id: idx + 1,    
      client_name: offer?.client,
      ta_name: offer?.ta,
      title: '['+offer?.qhcompanyjid+'] '+offer?.title,
      SPOC: offer?.spoc,
      assigned_to: offer?.assignedto,
      final_selected: offer?.numfinalselected===0?"-":offer?.numfinalselected,
      offered: offer?.numoffered===0?"-":offer?.numoffered,
      accepted: offer?.numoffered===0?"-":offer?.numofferaccepted,
      declined: offer?.numdeclined===0?"-":offer?.numdeclined,
      joined: offer?.numjoined===0?"-":offer?.numjoined,
      offer_hold: offer?.numofferonhold===0?"-":offer?.numofferonhold,
      bgv_fail: offer?.numbgvfail===0?"-":offer?.numbgvfail,
      bgv_ongoing: offer?.numbgvongoing===0?"-":offer?.numbgvongoing,
      bgv_ok: offer?.numbgvok===0?"-":offer?.numbgvok,
    };
  }); 

  return (
    <div className="myDashboard-wrapper">
      <Filter
        filtername = {"getMyDashBoardConsolidatedStats"}
        initDuration={"24"}
        initPrio={"All"}
        initJDStatus={"Active"}  
        initClient={"All"}             
        enableDuration
        enablePriority
        enableJdStatus
        enableCustomers  
        enableTAs             
        handleFilter={cb}
        pageSize={pageSize}
        pageNo={currentPage} 
        pageHandler = {setCurrentPage}       
      />      
      <div></div>

      {myDashConsolidatedStatsSelectionAndOffers ? (
        <>
            
            {currentView==="Final Selections/Offers"?
              <>
                <TableDashBoard
                  isClickable={true}
                  isJDPage={true}
                  titleList={finalSelectionList}
                  data={finalSelectionData}
                />            
              </>:<></>
            }                                        
        </>
        
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}

       <Pagination
              style={{ marginTop: "4px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={myDashConsolidatedStatsSelectionAndOffersCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
        />            
    </div>
  );
}
